// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"14888a97","245":"d942c9ff","293":"f336f6ce","731":"c7eaa6ac","744":"e85db391","896":"698a3336","904":"633837d1"}[chunkId] + ".chunk.js";
};